import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { BRAND_LUXE_PRIMARY } from '../brandDashboardTokens';

export function CampaignHostPaystackRedirectOverlay({
    open,
    provider = 'paystack',
}: {
    open: boolean;
    provider?: 'paystack' | 'flutterwave';
}) {
    if (!open) return null;
    const label = provider === 'flutterwave' ? 'Flutterwave' : 'Paystack';
    return (
        <Box
            sx={{
                position: 'fixed',
                inset: 0,
                zIndex: 9999,
                bgcolor: 'rgba(0,0,0,0.85)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
            }}>
            <CircularProgress sx={{ color: BRAND_LUXE_PRIMARY }} />
            <Typography sx={{ fontFamily: FONT_ENUM.MAIN_BOLD, fontSize: 18, color: '#fff' }}>
                Redirecting to {label}…
            </Typography>
        </Box>
    );
}
